import { Phone } from "lucide-react";

const StickyMobileCall = () => {
  return (
    <a
      href="tel:+17192327424"
      className="fixed bottom-0 left-0 right-0 z-50 lg:hidden bg-accent text-accent-foreground py-4 flex items-center justify-center gap-3 font-heading font-bold uppercase tracking-wide text-lg shadow-[0_-4px_20px_rgba(0,0,0,0.3)] hover:bg-accent/90 transition-colors"
      aria-label="Call Now - (719) 232-7424"
    >
      <Phone size={24} />
      Call Now - (719) 232-7424
    </a>
  );
};

export default StickyMobileCall;
